import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Maps from "../../../utils/maps";
import { MAP_TYPE } from "../../../constants/app-constants";
import currentMarkerIcon from "../../shared/images/centres-marker.svg";
import { INITIAL_STATE } from "./constants";
import styles from "./styles.css";
// import loadable from "@loadable/component";
// const Lottie = loadable(() => import("react-lottie"), { ssr: true });
// import Logo from "src/client/components/desktop/checkout-loader/logo.json";

const DreamCarGoogleMap = ({
    lat,
    lng,
    markerIcon = currentMarkerIcon,
    infoWindowContent,
    zoomControl = true,
    // eslint-disable-next-line no-magic-numbers
    height = 240,
    addMarker = true,
    stopZoom = false,
    addCenterListener = false,
    onCenterChanged = () => {},
    mapOptions = {},
    isBorderCurved = false,
    addCustomZoomControlOptions = false,
    customMarker = [],
    verticalOffsetPercent = 0,
    horizontalOffsetPercent = 0
}) => {
    const mapRef = useRef();
    const [map, setMapConnect] = useState(null);
    const [currentMarker, setCurrentMarkerConnect] = useState({});
    const [infoWindow, setInfoWindow] = useState({});
    // const { icon } = customMarker || {};

    useEffect(() => {
        if (!map && window.google && window.google.maps) {
            setMapConnect(Maps.getInstance(MAP_TYPE.GOOGLE).reInitMap(
                mapRef.current, {
                    ...INITIAL_STATE.mapOptions,
                    center: {lat, lng},
                    zoomControl,
                    hybrid: true,
                    ...(stopZoom && {
                        minZoom: INITIAL_STATE.mapOptions.zoom,
                        maxZoom: INITIAL_STATE.mapOptions.zoom
                    }),
                    ...mapOptions,
                    ...(addCustomZoomControlOptions && {
                        zoomControlOptions: {
                            position: window.google.maps.ControlPosition.RIGHT_TOP
                        }
                    })
                }
            ));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lat, lng, map, window.google]);

    useEffect(() => {
        if (!Object.keys(currentMarker).length && map) {
            setCurrentMarkerConnect(Maps.getInstance(MAP_TYPE.GOOGLE).initMarker({ map }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentMarker, map]);

    useEffect(() => {
        if (infoWindowContent) {
            setInfoWindow(Maps.getInstance(MAP_TYPE.GOOGLE).initInfoWindow());
        }
    }, [infoWindowContent]);

    useEffect(() => {
        if (lat !== 0 && lng !== 0 && !!Object.keys(currentMarker).length && addMarker) {
            Maps.getInstance(MAP_TYPE.GOOGLE).centerToPosition({
                marker: currentMarker,
                position: { lat, lng },
                markerIcon,
                ...(infoWindowContent && {
                    infoWindow,
                    infoWindowContent
                })
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, lat, lng, currentMarker]);

    useEffect(() => {
        if (map && Object.keys(currentMarker).length && addCenterListener) {
            Maps.getInstance(MAP_TYPE.GOOGLE).addCenterChangedListener(
                onCenterChanged
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, currentMarker]);

    useEffect(() => {

        if (map && customMarker && !!customMarker.length) {
            customMarker.map((item) => {
                return (
                    Maps.getInstance(MAP_TYPE.GOOGLE).initMarker({
                        position: {lat: item.lat, lng: item.lng},
                        map,
                        icon: item.icon
                    })
                );
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);

    useEffect(() => {
        if (!map) return;
        if (verticalOffsetPercent === 0 && horizontalOffsetPercent === 0) return;
        const listener = window.google.maps.event.addListenerOnce(map, "idle", () => {
            const h = map.getDiv().offsetHeight;
            const w = map.getDiv().offsetWidth;
            map.panBy(w * horizontalOffsetPercent, h * verticalOffsetPercent);
        });
        // eslint-disable-next-line consistent-return
        return () => window.google.maps.event.removeListener(listener);
    }, [map, verticalOffsetPercent, horizontalOffsetPercent]);

    return (<div
        ref={mapRef}
        style={{height, width: "100%"}}
        styleName={`styles.carDetailMap ${isBorderCurved ? "styles.topBorderCorner" : ""}`}
        id={"car-details-gmap"} />);
};

DreamCarGoogleMap.propTypes = {
    lat: PropTypes.string,
    lng: PropTypes.string,
    storeName: PropTypes.string,
    markerIcon: PropTypes.string,
    zoomControl: PropTypes.bool,
    height: PropTypes.number,
    infoWindowContent: PropTypes.any,
    stopZoom: PropTypes.bool,
    addMarker: PropTypes.bool,
    addCenterListener: PropTypes.bool,
    onCenterChanged: PropTypes.func,
    mapOptions: PropTypes.object,
    isBorderCurved: PropTypes.bool,
    addCustomZoomControlOptions: PropTypes.bool,
    customMarker: PropTypes.array,
    verticalOffsetPercent: PropTypes.number,
    horizontalOffsetPercent: PropTypes.number
};

export default DreamCarGoogleMap;
